export const BlockSeatingIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="24" height="24" rx="6" fill="url(#pattern0_8315_4765)" />
      <defs>
        <pattern
          id="pattern0_8315_4765"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_8315_4765" transform="scale(0.0434783)" />
        </pattern>
        <image
          id="image0_8315_4765"
          width="23"
          height="23"
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAIAAABvSEP3AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAupJREFUeNqcVE1LYmEU9t7etIygdNCNSdEHhUEIBmGtCgoCBdGJHIJC3ER/IRf+AKFomwtBaNUiEcFdkC2ClIqksYVK0Bc1BkmaH9c7T/cdNO91hqGzkPdez33Oc57znJdZ+bFy9fOKkTGyrwXD1DiOFApFto1lGOarIEyVqxBA1Go1KQrP85VKhWVZQggeccZve3u7FIWv8WzLCrwQIyMjarW6KoRer9fpdBRLGq1R3t/fV1dX9/b2dnd3e3t7p6amcA4GgyaTqVQq/S8KepyZmUEv/f39fX19ExMTXV1dPT09BoMBvKT5RPSMpDYhdnZ2XC5XNptNJBK3t7fDw8PlcjkcDisUCo7jkImchjoO+/dMNk3VRR74v76+dnZ2or5SqcQbMAI1yIyEfD4fj8c7OjpwLhQKcrn846tSucEFDS8tLa2trZ2dnQUCAZ/PBywR0+vra6/Xu7m5CVCPx4NHCkTqQ0HN5eVlnRCxWKxYLEpRoPrs7OzY2BjOCwsLl5eXFIVtmKdaPTg4AOfDw0PIQW0iVpGQ4+Pjm5sbKHV0dFS3TyMVsvn9/lAo9Pj4ODg42BIFORDbbrdD2re3tzrZJl3m5uacTufFxUU0GqWDEAVch9mvr6+D+/b29t3dHaXTpMvGxsbo6KjZbM5kMpiOFAWVFhcXoQjO6Hpra4uiNHRB8ZOTE1RLJpMPDw/wmBSlu7sb/+aFOD8/r3fd8Avo4HdoaOj+/h5nh8OhUqkwKWpleAQv0cL+/j6GSLmACD6BX9im7eR5lILrcrlcKpUaHx/XarUwMWaH6aIA5gKyGSE+7zcrWnNMAfqjO7fbDftaLBaj0Wi1WicnJ6enp+fn54EiF+Jfe0QDQJFIZGBgANZIpz/6tdls+P709FR6xYj3SDRUjUaDZYEv8AiNoM7Ly4sIhepC/nYVQv+npyck0UFAqZZ33Z9kGB+r1fLe/bz7IiE+c2FYhnxTq389P8tkX769ZaSN/BZgANgpfmt8vCZJAAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>
  );
};
